export const compareFunctionToSort = (a, b) => {
  const hasRecommIdA = Object.prototype.hasOwnProperty.call(a, "recommId");
  const hasRecommIdB = Object.prototype.hasOwnProperty.call(b, "recommId");

  if (hasRecommIdA && !hasRecommIdB) {
    return -1;
  } else if (!hasRecommIdA && hasRecommIdB) {
    return 1;
  } else {
    return 0;
  }
};
